import i18n, { init, t, TOptions } from 'i18next'

import { getI18nextInitParams } from './i18n-utils.js'

void init(getI18nextInitParams(false))

export interface TranslateOptions extends TOptions {
    lng: string // we override the default lng to be required, use empty string if you want to use current language
}

export const translate = (key: string, options: TranslateOptions) => {
    return t(key, options)
}

export default i18n
